export default function CarouselSkeleton() {
  return (
    <div className="overflow-hidden">
      <div className="flex gap-[15px]">
        {Array.from({ length: 4 }).map((_, idx) => (
          <div
            key={idx}
            className="flex flex-col gap-[10px] text-[#302e2d] animate-pulse"
          >
            {/* Image placeholder */}
            <div className="relative w-[324px] h-[323px] rounded-[4px] bg-gray-200" />

            {/* Text placeholders */}
            <div className="h-[24px] w-[70%] bg-gray-200 rounded" />
            <div className="h-[20px] w-[50%] bg-gray-200 rounded" />
            <div className="h-[20px] w-[60%] bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}
